<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span> {{ $t('subscription_class_form_title') }} </span>

                    <v-spacer></v-spacer>
                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <div class="row no-gutters">
                        <div class="col-md-6 pl-md-2">
                            <v-text-field
                                    v-model="value.name"
                                    :label="$t('name')"
                                    :rules="[rules.required]"
                            ></v-text-field>
                        </div>

                        <div class="col-md-6 pr-md-2">
                            <v-text-field
                                    v-model="value.caption"
                                    :label="$t('caption')"
                                    :message="$t('caption')"
                                    :rules="[rules.required]"
                            ></v-text-field>
                        </div>
                        <div class="col-md-6 pr-md-2">
                            <v-text-field
                                    class="ltr"
                                    type="number"
                                    v-model="value.limitation_send"
                                    :label="$t('limitation_send')"
                                    :rules="[rules.required]"
                            ></v-text-field>
                        </div>
                        <div class="col-md-6 pr-md-2">
                            <v-select
                                    :items="validity_duration_options"
                                    item-text="value"
                                    item-value="key"
                                    v-model="value.validity_duration"
                                    :label="$t('validity_duration')"
                                    :rules="[rules.required]"
                            ></v-select>
                        </div>
                        <div class="col-md-6 pr-md-2">
                            <v-text-field
                                    class="ltr"
                                    type="number"
                                    v-model="value.tax_rate"
                                    :label="$t('tax_rate')"
                                    :rules="[rules.required]"
                            ></v-text-field>
                        </div>
                        <div class="col-md-6 pr-md-2">
                            <v-text-field
                                    class="ltr"
                                    v-model="value.price"
                                    :value="value.price ? $n(value.amount) : null"
                                    suffix="ریال "
                                    @input="value.amount = parseInt($event)"
                                    :hint="priceToTomanPhrase(value.price)"
                                    :label="$t('price')"
                                    :rules="[rules.required]"
                            ></v-text-field>
                        </div>
                        <v-checkbox
                                v-model="value.user_selectable"
                                :label="$t('user_selectable')"
                                type="checkbox"
                        ></v-checkbox>

                    </div>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('submit')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    // Utils
    import { required } from '@/scripts/validationRules';
    import Service from "@/services/SubscriptionClassesService";
    import { priceToTomanPhrase } from '@/scripts/PriceUtils';

    export default {
        props: {
            item: {
                required: true
            }
        },
        computed : {
            validity_duration_options(){
                return Object.keys(this.$t("validity_duration_options")).map(key => {
                    return {
                        key,
                        value: this.$t("validity_duration_options")[key]
                    }
                })
            }
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                value : {...this.item},
                rules: {
                    required
                },

            }
        },
        methods: {
            priceToTomanPhrase,

            async submit() {
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');


            }
        }
    }
</script>